// extracted by mini-css-extract-plugin
export default {"maskedNumber":"g2GZKAz0d9uUh5a0Hc1E","dots":"f_zlRlh1w7C90HvjPC2O"};